module.exports = __webpack_public_path__ + "img/dp.9aee6999.png";